export const API_REQUEST = "API_REQUEST";
export const API_SUCCESS = "API_SUCCESS";
export const API_FAILURE = "API_FAILURE";

/**
 * Action creator for API requests
 */
export const apiRequest = ({
  url,
  method = "GET",
  data = null,
  headers = {},
  onSuccessKey,
  onErrorKey,
  handleSuccess,
  handleError,
}) => {
  //console.log("handleError", onErrorKey); // ✅ Log before returning the action
  return {
    type: API_REQUEST,
    payload: { url, method, data, headers, onSuccessKey, onErrorKey, handleSuccess, handleError },
  };
};
